<template>
    <div id="app" class="m-0 h-100">
       
            <app-header v-if="$route.meta.requiresHeader"></app-header>
            <router-view />
            <app-footer v-if="$route.meta.requireFooter"></app-footer>
       
    </div>

</template>

<script>
    import Navbar from './components/Navbar/Navbar.vue'
    import Footer from './components/Footer/Footer.vue'
    export default {
        name: 'app',
        components: {
            'app-header': Navbar,
            'app-footer': Footer
        }
    };
</script>
<style lang="scss">
</style>

